export const msalConfig = {
  auth: {
    clientId: "ba1b01a8-bd5e-4813-8b17-dda8c6c428df",
    authority: "https://login.microsoftonline.com/2bb9d9be-cc65-47e4-9ec4-c46906f5030a",
    redirectUri: "https://payouts.magoonllc.com",
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["User.Read", "Sites.Read.All", "Files.Read.All"],
};

export const SHAREPOINT_SITE      = "choresor.sharepoint.com";
export const SHAREPOINT_SITE_PATH = "/sites/Payouts";
export const PAYOUTS_LIST         = "Payouts";
